export const DUE_DATE_DRAWER_STAGES = {
  INITIAL: 'initial',
  SUCCESS: 'success',
  DISABLED: 'disabled',
}
